import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from 'app/components/Form/Button/IconButton';
import { MUIButton } from 'app/components/Form/Button/MUIButton.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
export function ExpansionPanelButton(props) {
    const { icon, label, to, onClick } = props;
    let button;
    if (icon && !label) {
        button = (_jsx(IconButton, { style: { height: '100%' }, onClick: onClick, to: to, children: _jsx(FontIcon, { style: { fontSize: 17 }, icon: icon }) }));
    }
    else {
        button = (_jsxs(MUIButton, { onClick: onClick, to: to, children: [icon && _jsx(FontIcon, { style: { marginRight: 5, fontSize: 17 }, icon: icon }), label] }));
    }
    return (_jsx("div", { onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
        }, children: button }));
}
